import { ViewStyle } from 'react-native';
import {
    BASE_GAP,
    FULLSCREEN_BOTTOMTAB_GAP,
    FULLSCREEN_STICKY_GAP,
} from '@24i/nxg-core-utils/src/constants';
import { isWebMobile } from '@24i/nxg-sdk-higgs/src/utils';

export type StickyBackHeaderStyles = {
    wrapper: ViewStyle;
    textContainer: ViewStyle;
};

export const styles: StickyBackHeaderStyles = {
    wrapper: {
        // @ts-ignore: used for web only
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
        width: '100%',
    },
    textContainer: {
        padding: BASE_GAP,
        ...(isWebMobile() && {
            '@media (min-width: 801px)': {
                marginTop: -FULLSCREEN_STICKY_GAP,
            },
        }),
        ...(!isWebMobile() && {
            '@media (min-width: 801px)': {
                marginTop: FULLSCREEN_BOTTOMTAB_GAP,
            },
        }),
    },
};
